module.exports = __webpack_public_path__ + "static/stageSet9-f6f31a78b7938be15cf43c1e912510b9.jpg";